<!-- Start Contact -->
<!--!&#45;&#45; Hero Start &ndash;&gt;-->
<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/pexels-picjumbocom-225232.jpg') center center; background-size: cover">
  <div class="bg-overlay"></div>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-7 col-md-6">

        <div class="title-heading mt-4">
          <h1 class="display-4 font-weight-bold text-white title-dark mb-3" style="font-size: 38px !important;">
            Contact us
          </h1>
        </div>
      </div>
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<section class="section pt-1 mt-1" >
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 p-0">
        <div class="card map border-0">
          <div class="card-body p-0">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.9525342625916!2d79.85015191477483!3d7.246242494769223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2e904910a7d6f%3A0x5b6465e1daa8376!2s3R%20International!5e0!3m2!1sen!2slk!4v1619769641875!5m2!1sen!2slk" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0 order-2 order-md-1">
        <div class="card custom-form rounded shadow border-0">
          <div class="card-body">
            <div id="message"></div>
            <form [formGroup]="contactForm" class="login-form">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group position-relative">
                    <label>Your Name <span class="text-danger">*</span></label>
                    <i-feather name="user" class="fea icon-sm icons"></i-feather>
                    <input name="name" formControlName="name" id="name" type="text"
                           class="form-control pl-5" placeholder="First Name :">
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="form-group position-relative">
                    <label>Your Email <span class="text-danger">*</span></label>
                    <i-feather name="mail" class="fea icon-sm icons"></i-feather>
                    <input name="email" id="email" formControlName="email" type="email"
                           class="form-control pl-5" placeholder="Your email :">
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-12">
                  <div class="form-group position-relative">
                    <label>Comments</label>
                    <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                    <textarea name="comments" formControlName="coment" id="comments" rows="4"
                              class="form-control pl-5"
                              placeholder="Your Message :"></textarea>
                  </div>
                </div>
              </div>
              <!--end row-->
              <div class="row">
                <div class="col-sm-12 text-center">
                  <button class="submitBnt btn btn-primary btn-block" (click)="sendmail()">Send Message</button>
                  <div id="simple-msg"></div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </form>
            <!--end form-->
          </div>
        </div>
        <!--end custom-form-->
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-6 order-1 order-md-2">
        <div class="title-heading ml-lg-4">
          <h4 class="mb-4">Contact Details</h4>

<!--          <div class="media contact-detail align-items-center mt-3">-->
<!--            <div class="icon">-->
<!--              <i-feather name="mail" class="fea icon-m-md text-dark mr-3"></i-feather>-->
<!--            </div>-->
<!--            <div class="media-body content">-->
<!--              <h4 class="title font-weight-bold mb-0">Travels</h4>-->
<!--              <a href="mailto:contact@example.com" class="text-primary">info@3rgroup.lk</a>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="media contact-detail align-items-center mt-3">-->
<!--            <div class="icon">-->
<!--              <i-feather name="mail" class="fea icon-m-md text-dark mr-3"></i-feather>-->
<!--            </div>-->
<!--            <div class="media-body content">-->
<!--              <h4 class="title font-weight-bold mb-0">Sales</h4>-->
<!--              <a href="mailto:contact@example.com" class="text-primary">sales@3rgroup.lk</a>-->
<!--            </div>-->
<!--          </div>-->
          <div class="media contact-detail align-items-center mt-3">
            <div class="icon">
              <i-feather name="mail" class="fea icon-m-md text-dark mr-3"></i-feather>
            </div>
            <div class="media-body content">
              <h4 class="title font-weight-bold mb-0">Web inquires</h4>
              <a href="mailto:contact@example.com" class="text-primary">info@3rgroup.lk</a>
            </div>
          </div>
          <div class="media contact-detail align-items-center mt-3">
            <div class="icon">
              <i-feather name="mail" class="fea icon-m-md text-dark mr-3"></i-feather>
            </div>
            <div class="media-body content">
              <h4 class="title font-weight-bold mb-0">Promotions</h4>
              <a href="mailto:contact@example.com" class="text-primary">sales@3rgroup.lk</a>
            </div>
          </div>

          <div class="media contact-detail align-items-center mt-3">
            <div class="icon">
              <i-feather name="mail" class="fea icon-m-md text-dark mr-3"></i-feather>
            </div>
            <div class="media-body content">
              <h4 class="title font-weight-bold mb-0">Ticketing</h4>
              <a href="mailto:contact@example.com" class="text-primary">tickets@3rgroup.lk</a>
            </div>
          </div>

          <div class="media contact-detail align-items-center mt-3">
            <div class="icon">
              <i-feather name="phone" class="fea icon-m-md text-dark mr-3"></i-feather>
            </div>
            <div class="media-body content">
              <h4 class="title font-weight-bold mb-0">Hotline</h4>
              <a href="tel:+152534-468-854" class="text-primary">Rakitha - 0777776368</a>
            </div>
          </div>

<!--          <div class="media contact-detail align-items-center mt-3">-->
<!--            <div class="icon">-->
<!--              <i-feather name="phone" class="fea icon-m-md text-dark mr-3"></i-feather>-->
<!--            </div>-->
<!--            <div class="media-body content">-->
<!--              <h4 class="title font-weight-bold mb-0">Phone</h4>-->
<!--              <a href="tel:+152534-468-854" class="text-primary">(+94) 31 2272477</a>-->
<!--            </div>-->
<!--          </div>-->

          <div class="media contact-detail align-items-center mt-3">
            <div class="icon">
              <i-feather name="map-pin" class="fea icon-m-md text-dark mr-3"></i-feather>
            </div>
            <div class="media-body content">
              <h4 class="title font-weight-bold mb-0">Location</h4>
              <a href="https://goo.gl/maps/U6KEkuBCyuHs166K8"
                class="video-play-icon text-primary">View on Google map</a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- End contact -->


<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
  [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
